import { useApiClient, useFetch } from '@marageti/z4-lib';
import { AgentWithUnreadCount } from '@marageti/z4-sdk/lib/travel';
import { useAuthStore } from '../store';

/** @param agentId - When provided, unread count is for this agent; otherwise for the logged-in agent */
function useUnreadCount(agentId?: string) {
  const apiClient = useApiClient();
  const { loggedInAgent } = useAuthStore();
  const partnerId = loggedInAgent?.partnerId;

  const {
    data,
    error,
    isLoading,
    mutate,
  } = useFetch<AgentWithUnreadCount[]>(
    apiClient.partnersClient.getPartnerAgentsWithUnread,
    [partnerId],
    !!partnerId,
    { refreshInterval: 1000 * 60 * 3 },
  );

  const resolvedAgentId = agentId ?? loggedInAgent?.id;
  const unreadCount = resolvedAgentId
    ? data?.find((a) => a.id === resolvedAgentId)?.unreadConversationCount
    : undefined;

  return {
    unreadCount,
    unreadCountLabel: unreadCount !== undefined ? `${unreadCount}` : '-',
    data,
    error,
    isLoading,
    mutate,
  };
}

export default useUnreadCount;
